import { Cesium } from './../../cesium';
import lodash from 'lodash';

// Unfortunately Cesium's cartesian3 has a toString method but not the opposite.
//angular.module('ims.shared').service('Cartesian3Util', function(lodash, Cesium) {

export class Cartesian3Util {
    _Cesium;

    constructor(Cesium) {
        this._Cesium = Cesium;
    }

    /**
     * Parse the output from a Cesium.Cartesian3.toString() call back into a
     * Cartesian3 object.
     * @param cartesian3String
     * @returns {Cesium.Cartesian3|{fromElements}}
     */
    parse(cartesian3String: string): Cesium.Cartesian3 {
        cartesian3String = lodash.trim(cartesian3String, '()');
        let components = lodash.split(cartesian3String, ',');
        let x = parseFloat(components[0]);
        let y = parseFloat(components[1]);
        let z = parseFloat(components[2]);

        if (!lodash.isNaN(x) && !lodash.isNaN(y) && !lodash.isNaN(z)) {
            return new this._Cesium.Cartesian3(x, y, z);
        } else {
            return null;
        }
    }

    /**
     * Takes in an ordered array (x,y,z) and turns it into a Cartesian3 object.
     * @param ObjectArray
     */
    parseObjectArray(ObjectArray: Array<{ value: number }>): Cesium.Cartesian3 {
        let x = ObjectArray[0].value;
        let y = ObjectArray[1].value;
        let z = ObjectArray[2].value;
        if (!lodash.isNaN(x) && !lodash.isNaN(y) && !lodash.isNaN(z)) {
            return new this._Cesium.Cartesian3(x, y, z);
        } else {
            return null;
        }
    }
}
